// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".registration-certificate-content[data-v-37ab5db2]{width:100%;margin-top:20px;margin-left:18px}.registration-certificate-content .pagination[data-v-37ab5db2]{margin-top:16px}.manageRange[data-v-37ab5db2]{width:100%;max-height:120px;overflow-x:hidden}.manageRange[data-v-37ab5db2] .el-select__tags{max-height:120px!important}.content[data-v-37ab5db2]{height:auto}", ""]);
// Exports
module.exports = exports;
